/* eslint-disable @shopify/binary-assignment-parens */

export default {
  name: 'cartTimer',
  component(props: { cartTimerMinutes: number }) {
    return {
      cartHasItems: false,
      timeRemaining: 0,
      timeRemainingFormatted: '00:00',
      cartCount: 0,
      cartTimerMinutes: props.cartTimerMinutes,
      intervalId: null as ReturnType<typeof setInterval> | null,
      onCartUpdateHandler: undefined as unknown as (e: Event) => void,

      async init() {
        await this.initTimer()
        this.initCartUpdateListener()
      },

      async initTimer() {
        await this.checkCartItems()
        this.setEndTimer()
        this.startTimer()
      },

      async checkCartItems(onUpdate = false) {
        try {
          const response = await fetch('/cart.js')
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          const data = await response.json()

          this.cartHasItems = data.item_count > 0

          if (onUpdate && data.item_count > this.cartCount) {
            // Restart timer with new time when items are added
            this.setEndTimer(true)
          }

          this.cartCount = data.item_count
        } catch (error) {
          console.error('[cartTimer]: Error fetching cart data:', error)
        }
      },

      setEndTimer(restart = false) {
        const hasEndTimer = this.getLocalEndTimer() !== null && this.getLocalEndTimer() !== ''

        if (restart || (!hasEndTimer && this.cartHasItems && this.cartTimerMinutes > 0)) {
          const endTimer = new Date().getTime() + this.cartTimerMinutes * 60 * 1000
          this.setLocalEndTimer(new Date(endTimer).toISOString())
        } else if (hasEndTimer && !this.cartHasItems) {
          this.setLocalEndTimer('')
        }
      },

      startTimer() {
        // Clean up existing interval before creating a new one
        this.stopTimer()

        const endTimerValue = this.getLocalEndTimer()
        if (!this.cartHasItems || !endTimerValue) {
          return
        }

        const endTimer = new Date(endTimerValue)
        const now = new Date()
        this.timeRemaining = Math.max(0, endTimer.getTime() - now.getTime())

        this.setTimer()

        if (this.timeRemaining > 0) {
          this.intervalId = setInterval(() => {
            if (this.timeRemaining > 0) {
              this.setTimer()
            } else {
              this.stopTimer()
            }
          }, 1000)
        }
      },

      stopTimer() {
        if (this.intervalId !== null) {
          clearInterval(this.intervalId)
          this.intervalId = null
        }
      },

      setTimer() {
        const endTimerValue = this.getLocalEndTimer()
        if (endTimerValue && this.timeRemaining > 0) {
          const endTimer = new Date(endTimerValue)
          const now = new Date()
          this.timeRemaining = Math.max(0, endTimer.getTime() - now.getTime())
        } else {
          this.timeRemaining = 0
        }

        const minutes = Math.floor(this.timeRemaining / (1000 * 60))
        const seconds = Math.floor((this.timeRemaining % (1000 * 60)) / 1000)
        this.timeRemainingFormatted = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      },

      initCartUpdateListener() {
        this.onCartUpdateHandler = this.onCartUpdate.bind(this)
        document.addEventListener('liquid-ajax-cart:request-end', this.onCartUpdateHandler)
      },

      async onCartUpdate() {
        await this.checkCartItems(true)
        this.setEndTimer()
        this.startTimer()
      },

      setLocalEndTimer(value: string) {
        localStorage.setItem('cartEndTimer', value)
      },

      getLocalEndTimer() {
        return localStorage.getItem('cartEndTimer')
      },

      destroy() {
        this.stopTimer()
        if (this.onCartUpdateHandler) {
          document.removeEventListener('liquid-ajax-cart:request-end', this.onCartUpdateHandler)
        }
      }
    }
  }
}
